module.exports = __webpack_public_path__ + "static/media/takeaway_outline_black.c34c5f31.svg";